import React from "react";
import './Main.css';
import MainMenu from "./MainMenu";

const Main = () => {
    return (
        <div id="Menu">
            <div className="Main">

            <h1>Menu</h1>
            <MainMenu />
            </div>
        </div>
    )
}

export default Main;